import { computed } from "mobx";
import {
  ExtendedModel,
  isoStringToDateTransform,
  modelAction,
  tProp,
  types,
} from "mobx-keystone";
import { TModel } from "../../lib/models/t-model";
import { meterReadingNS } from "./ns.meter-reading";
import type { Self } from "../../lib/models/ref";

@meterReadingNS.model
export class MeterReadingModel extends ExtendedModel(TModel, {
  consumption: tProp(types.number),
  daysInCycle: tProp(types.number),
  unitOfMeasure: tProp(types.string),
  cost: tProp(types.number),
  registerNum: tProp(types.string),
  runningReading: tProp(types.number),
  meterId: tProp(types.string),
  measuredAt: tProp(types.string).withTransform(isoStringToDateTransform()),
}) {
  @computed
  get meter() {
    if (!this.detaching && this.root) {
      const meter = this.root.tilliX.meters.modelRef(this.meterId);

      return meter.maybeCurrent;
    }

    // biome-ignore lint/nursery/noUselessUndefined: <return undefined for getter>
    return undefined;
  }

  @modelAction
  protected _setValueForKey<K extends keyof this & keyof Self<this>>(
    key: K,
    value: Self<this>[K] | this[K],
  ): void {
    this[key] = value;
  }
}
